"use strict";

angular.module("preciseCurrency").filter("preciseCurrency", function($filter) {
    return function(currency) {
        currency = parseFloat(parseFloat(currency).toFixed(5));
        var decimalCount = decimalPlaces(currency);
        var precision = Math.max(decimalCount, 2);
        return $filter("currency")(currency, undefined, precision);
    };
});

//http://stackoverflow.com/a/10454560/2115513
function decimalPlaces(num) {
    var match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }

    return Math.max(
        0,
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0) -
        // Adjust for scientific notation.
        (match[2] ? +match[2] : 0)
    );
}



//////////////////
// WEBPACK FOOTER
// ./core/precise-currency/precise-currency.filter.js
// module id = 319
// module chunks = 0